@if ((customerData$ | async) || {}; as customer) {
<tux-page-header
  pageTitle="Platform Customers"
  [breadcrumbs]="[
    { path: '', title: 'Home' },
    { path: '/application-manager', title: 'Current Customers' },
    { title: customer.name || 'Customer' }
  ]"
  [subMenu]="false"
>
  <tux-page-header-buttons>
    <p-button
      label="Manage Users"
      [outlined]="true"
      styleClass="surface-border font-medium"
      [routerLink]="[
        '/home/application-manager/' + customer.customerId + '/manage-users'
      ]"
    ></p-button>
    <p-button
      label="Edit Customer"
      [outlined]="true"
      styleClass="font-medium"
      (click)="editCustomer()"
    ></p-button>
    <p-button
      type="primary"
      label="Add App Instance"
      styleClass="font-medium"
      (click)="addAppInstanceVisible = true"
    ></p-button>
  </tux-page-header-buttons>

  <div ngProjectAs="tux-metadata">
    <div class="flex gap-4 w-full">
      <div class="flex gap-2">
        <span class="font-medium">CRM Org ID</span
        ><span>{{ customer?.internalCrmId }}</span>
      </div>
      <div class="flex gap-2">
        <span class="font-medium">Primary Contact</span
        ><span>{{ customer?.contactEmail }}</span>
      </div>
      <div class="flex gap-2">
        <span class="font-medium">Account Owner</span
        ><span>{{ customer?.owner }}</span>
      </div>
    </div>
  </div>
</tux-page-header>

<div class="flex flex-column gap-4">
  <h3 class="font-normal text-700">App Instances</h3>

  @if (sortedStackedCustomerAppInstances$ | async; as appInstances) { @for
  (appInstance of appInstances; track appInstance) {

  <p-table
    [value]="[appInstance]"
    dataKey="instanceId"
    [expandedRowKeys]="expandedInstances[appInstance.instanceId || '']"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 400px" class="text-600">Data Studio Instance</th>
        <th style="width: 200px" class="text-600">Type</th>
        <th style="width: 400px" class="text-600">Instance ID's</th>
        <th class="text-600">Status</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td>
          @if (row.type === 'DATA_STUDIO') {
          <tux-link [path]="['data-studio', row.instanceId]">
            {{ row.name }}
          </tux-link>
          } @else if (row.type === 'ADX') {
          <tux-link [path]="['adex', row.instanceId]">
            {{ row.name }}
          </tux-link>
          } @else {
          {{ row.name }}
          }
        </td>
        <td>{{ row.type }}</td>
        <td>{{ row.instanceId }}</td>
        <td>{{ row.status || '-' }}</td>
      </tr>
    </ng-template>
    <ng-template #expandedrow let-row>
      <tr *ngIf="row?.children.length">
        <td colspan="4" class="p-0 py-2">
          <div class="border-left-3 border-200">
            <p-table [value]="row.children" styleClass="p-3 pr-0">
              <ng-template pTemplate="header">
                <tr>
                  <!-- not 400 for the offset on the left of the table -->
                  <th style="width: 385px" class="text-600">App Name</th>
                  <th style="width: 200px" class="text-600">Type</th>
                  <th style="width: 400px" class="text-600">Instance ID's</th>
                  <th class="text-600">Status</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>
                    @if (row.type === 'DATA_STUDIO') {
                    <tux-link [path]="['data-studio', row.instanceId]">
                      {{ row.name }}
                    </tux-link>
                    } @else if (row.type === 'ADX') {
                    <tux-link [path]="['adex', row.instanceId]">
                      {{ row.name }}
                    </tux-link>
                    } @else {
                    {{ row.name }}
                    }
                  </td>
                  <td>{{ row.type }}</td>
                  <td>{{ row.instanceId }}</td>
                  <td>{{ row.status || '-' }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  } @empty {
  <!-- empty app instances -->
  <!-- Empty message with optional event -->
  <div class="empty-table-container">
    <tux-svg [src]="errorLogo"></tux-svg>
    <span class="empty-table-title">No App Instances Found </span>
  </div>
  } } @else {

  <!-- loading app instances -->
  <div class="empty-table-container">
    <tux-svg [src]="errorLogo"></tux-svg>
    <!-- <span class="empty-table-title">
      <p-progressSpinner
        styleClass="w-2rem h-2rem"
        strokeWidth="3"
        fill="var(--surface-200)"
        animationDuration=".5s"
      ></p-progressSpinner>
      Loading...
    </span>
    <span class="empty-table-description">
      Please wait while we load your data.
    </span> -->
  </div>
  }

  <!-- End content -->
</div>
}

<p-dialog
  [(visible)]="addAppInstanceVisible"
  [modal]="true"
  [style]="{ width: '35rem', 'min-height': 'fit-content' }"
  contentStyleClass="overflow-visible"
  header="Add App Instance"
>
  <div class="field flex flex-column">
    <!-- first row of options -->
    <div class="flex gap-2 no-wrap justify-content-between">
      <div class="field w-full">
        <label for="instance-type">Select Instance Type</label>
        <p-select
          #instanceTypeDropdown
          [formControl]="appInstanceForm.controls.instanceType"
          [options]="instanceTypes"
          inputId="instance-type"
          placeholder="Enter Instance"
          size="small"
          styleClass="w-full"
        ></p-select>
      </div>

      @if (instanceTypeDropdown.value === 'DATA_STUDIO') {
      <div class="field flex flex-column">
        <label for="list-based-toggle" class="text-center white-space-nowrap"
          >List Based</label
        >
        <div class="flex justify-content-between">
          <p-toggleSwitch
            #listBasedToggle
            inputId="list-based-toggle"
            [formControl]="
              appInstanceForm.controls.dataStudioInstanceForm.controls
                .isListBased
            "
          />
          <span>{{
            appInstanceForm.controls.dataStudioInstanceForm.controls.isListBased
              .value
              ? 'Yes'
              : 'No'
          }}</span>
        </div>
      </div>
      <div class="field flex flex-column">
        <!-- APPS-2544-->
        <label for="intent-topic-limit">Intent Topic Limit</label>
        <p-select
          inputId="intent-topic-limit"
          size="small"
          styleClass="w-full"
          [options]="intentTopicLimitOptions"
          [formControl]="
            appInstanceForm.controls.dataStudioInstanceForm.controls
              .intentTopicLimit
          "
        ></p-select>
      </div>

      } @else if (instanceTypeDropdown.value === 'ADX') {
      <div class="field w-2">
        <label for="country_code_input">Country Code</label>
        <p-select
          inputId="country_code_input"
          size="small"
          styleClass="w-full"
          [required]="true"
          [options]="countryCodes"
          [filter]="true"
          [formControl]="
            appInstanceForm.controls.adexInstanceForm.controls.country_code
          "
        ></p-select>
      </div>
      }
    </div>

    <!-- second row of options -->
    <div class="field flex flex-column">
      <label for="instance-name">Instance Name</label>
      <input
        [formControl]="appInstanceForm.controls.instanceName"
        inputId="instance-type"
        pInputText
        pSize="small"
        placeholder="Enter Name"
        styleClass=" w-full"
      />
    </div>

    @if (instanceTypeDropdown.value === 'ADVERTISER') {
    <div class="field flex flex-column">
      <label for="instance-name">Advertiser ID</label>
      <input
        [formControl]="
          appInstanceForm.controls.advertiserInstanceForm.controls.advertiserId
        "
        [required]="
          appInstanceForm.controls.instanceType.value === 'ADVERTISER'
        "
        inputId="advertiser-id"
        pInputText
        pSize="small"
        placeholder="Enter ID"
        styleClass=" w-full"
      />
    </div>
    }

    <!-- third row of options -->
    <div class="field flex flex-column">
      <label for="instance-align">Align to Data Studio Instance</label>
      @if ((customerAppAlignmentOptions$ | async); as appInstances) {
      <p-select
        [disabled]="
          appInstances.length === 0 ||
          appInstanceForm.controls.instanceType.value === 'DATA_STUDIO'
        "
        [required]="
          appInstanceForm.controls.instanceType.value === 'DATA_STUDIO'
            ? false
            : true
        "
        size="small"
        styleClass=" w-full"
        inputId="instance-align"
        [options]="appInstances"
        optionLabel="name"
        optionValue="instanceId"
        placeholder="Enter Instance"
        [formControl]="appInstanceForm.controls.instanceParentId"
      >
        <ng-template let-item pTemplate="item">
          <span>{{ item.type }} - {{ item.name }}</span>
        </ng-template>
      </p-select>
      }
    </div>
  </div>

  <div class="flex justify-content-end gap-2">
    <p-button
      (onClick)="addAppInstanceVisible = false; appInstanceForm.reset()"
      [outlined]="true"
      label="Cancel"
    />
    <p-button
      (onClick)="addAppInstance()"
      [disabled]="appInstanceForm.invalid"
      label="Save"
    />
  </div>
</p-dialog>
